import styled from "styled-components";
import { colorsPalettes, fonts, mixins } from "@similarweb/styles";

export const CUSTOM_MODAL_STYLES = {
    content: { padding: 0, width: "43%", minWidth: 300, maxWidth: 550, minHeight: 125 },
};

export const StyledFooter = styled.div`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    padding: 0 16px 16px;

    & > *:not(:first-child) {
        margin-left: 4px;
    }
`;

export const StyledBody = styled.div`
    flex-grow: 1;
    padding: 16px 24px;
`;

export const StyledHeader = styled.h3`
    ${mixins.setFont({
        $color: colorsPalettes.carbon["500"],
        $family: fonts.$dmSansFontFamily,
        $weight: 500,
        $size: 20,
    })};
    flex-shrink: 0;
    line-height: 24px;
    margin: 0;
    padding: 20px 24px;
`;

export const StyledModalInner = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
`;
